"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M10.3 2.291 4.37 8.218a.249.249 0 0 1-.177.073H2a2 2 0 0 0-2 2v3.414a2 2 0 0 0 2 2h2.193a.25.25 0 0 1 .177.074l5.93 5.926A1 1 0 0 0 12 21V3a1 1 0 0 0-1.7-.709Zm7.29 2.675a1 1 0 0 0-1.414 1.414 7.944 7.944 0 0 1 0 11.239 1 1 0 0 0 1.414 1.414 9.943 9.943 0 0 0 0-14.067Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M20.041 2.434a1 1 0 0 0-1.414 1.414 11.542 11.542 0 0 1 0 16.3 1 1 0 1 0 1.414 1.414 13.543 13.543 0 0 0 0-19.128Zm-4.9 5.066a1 1 0 1 0-1.416 1.413 4.379 4.379 0 0 1 0 6.179A1 1 0 1 0 15.14 16.5a6.382 6.382 0 0 0 .001-9Z"
})), 'VolumeFull');

exports.default = _default;